import { useTranslation } from "react-i18next";
import { useGetActionPlanStatistics } from "../../../api/ActionPlanApi";
import ContentContainer from "../../../components/ContainerComponents/ContentContainer";
import LoadingSpinner from "../../../components/LoadingSpinner";
import When from "../../../components/When";
import { ActionPlanStatus, ActionPlanTypeViewName } from "../../../core/enums/enums";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Payload } from "recharts/types/component/DefaultTooltipContent";

const ActionPlanStatistics = () => {

  const { t } = useTranslation();
  const ORDER = ['countCreated', 'countOnGoing', 'countCompleted'];
  const [statistics, isFetching] = useGetActionPlanStatistics();

  const TYPE_LABELS: Record<ActionPlanTypeViewName, string> = {
    ACCIDENT: t('ACTION_PLAN_TYPE_GROUPED.ACCIDENT'),
    INCIDENT: t('ACTION_PLAN_TYPE_GROUPED.INCIDENT'),
    DEVIATION: t('ACTION_PLAN_TYPE_GROUPED.DEVIATION'),
    ACTIONPLAN: t('ACTION_PLAN_TYPE_GROUPED.ACTIONPLAN'),
    ACCIDENT_INCIDENT: t('ACTION_PLAN_TYPE_GROUPED.ACCIDENT_INCIDENT')
  };

  const STATUS_LABELS: Record<ActionPlanStatus, string> = {
    CREATED: t('ACTION_PLAN_STATUS.CREATED'),
    ONGOING: t('ACTION_PLAN_STATUS.ONGOING'),
    COMPLETED: t('ACTION_PLAN_STATUS.COMPLETED')
  };

  const COLORS = {
    created: '#842029',  
    ongoing: '#7a94b7',  
    completed: '#b0e088',
  };

  return (
    <>
      <ContentContainer style={{ padding: "10px", overflow: "auto", height: "25rem" }}>
        <div className="text-center col">{t("ActionPlanStatistics.INCIDENTSANDACTIONS")}</div>
        {isFetching ? <LoadingSpinner spinnerAnimation="border" /> :
          <When condition={statistics.length > 0} otherwise={t('ActionPlanStatistics.ACTION_PLAN_MISSING_1')}>
            <ResponsiveContainer width="100%" height="93%">
              <BarChart
                data={statistics}
                margin={{ top: 16, right: 24, left: 8, bottom: 8 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis padding={{ left: 20 }} dataKey="type" textAnchor="middle" height={30} tickFormatter={(value: string) => TYPE_LABELS[value as ActionPlanTypeViewName] ?? value} />
                <YAxis allowDecimals={false} width="auto" />
                <Tooltip
                  labelFormatter={(label: string) => {
                      return (TYPE_LABELS[label as ActionPlanTypeViewName] ?? label).toUpperCase();
                  }}
                  itemSorter={(item: Payload<number, string>) =>
                    ORDER.indexOf(item.dataKey as string)
                  }
                />
                <Legend verticalAlign="top" />
                
                {/* En stapel per status */}
                <Bar dataKey="countCreated" name={t(STATUS_LABELS[ActionPlanStatus.CREATED])} fill={COLORS.created} />
                <Bar dataKey="countOnGoing" name={t(STATUS_LABELS[ActionPlanStatus.ONGOING])} fill={COLORS.ongoing} />
                <Bar dataKey="countCompleted" name={t(STATUS_LABELS[ActionPlanStatus.COMPLETED])} fill={COLORS.completed} />
              </BarChart>
            </ResponsiveContainer>
          </When>
        }
      </ContentContainer>
    </>
  )
}

export default ActionPlanStatistics
